var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"custom-form"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.code)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }